"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CalculateAgeAt = exports.CalculateAge = exports.Concept = exports.ConceptRef = exports.ConceptDef = exports.Code = exports.CodeRef = exports.CodeDef = exports.CodeSystemDef = exports.InValueSet = exports.AnyInValueSet = exports.ValueSetRef = exports.ValueSetDef = void 0;
var expression_1 = require("./expression");
var dt = __importStar(require("../datatypes/datatypes"));
var builder_1 = require("./builder");
var ValueSetDef = /** @class */ (function (_super) {
    __extends(ValueSetDef, _super);
    function ValueSetDef(json) {
        var _this = _super.call(this, json) || this;
        _this.name = json.name;
        _this.id = json.id;
        _this.version = json.version;
        return _this;
    }
    //todo: code systems and versions
    ValueSetDef.prototype.exec = function (ctx) {
        return __awaiter(this, void 0, void 0, function () {
            var valueset;
            return __generator(this, function (_a) {
                valueset = ctx.codeService.findValueSet(this.id, this.version) || new dt.ValueSet(this.id, this.version);
                ctx.rootContext().set(this.name, valueset);
                return [2 /*return*/, valueset];
            });
        });
    };
    return ValueSetDef;
}(expression_1.Expression));
exports.ValueSetDef = ValueSetDef;
var ValueSetRef = /** @class */ (function (_super) {
    __extends(ValueSetRef, _super);
    function ValueSetRef(json) {
        var _this = _super.call(this, json) || this;
        _this.name = json.name;
        _this.libraryName = json.libraryName;
        return _this;
    }
    ValueSetRef.prototype.exec = function (ctx) {
        return __awaiter(this, void 0, void 0, function () {
            var valueset;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        valueset = ctx.getValueSet(this.name, this.libraryName);
                        if (!(valueset instanceof expression_1.Expression)) return [3 /*break*/, 2];
                        return [4 /*yield*/, valueset.execute(ctx)];
                    case 1:
                        valueset = _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/, valueset];
                }
            });
        });
    };
    return ValueSetRef;
}(expression_1.Expression));
exports.ValueSetRef = ValueSetRef;
var AnyInValueSet = /** @class */ (function (_super) {
    __extends(AnyInValueSet, _super);
    function AnyInValueSet(json) {
        var _this = _super.call(this, json) || this;
        _this.codes = (0, builder_1.build)(json.codes);
        _this.valueset = new ValueSetRef(json.valueset);
        return _this;
    }
    AnyInValueSet.prototype.exec = function (ctx) {
        return __awaiter(this, void 0, void 0, function () {
            var valueset, codes;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.valueset.execute(ctx)];
                    case 1:
                        valueset = _a.sent();
                        // If the value set reference cannot be resolved, a run-time error is thrown.
                        if (valueset == null || !valueset.isValueSet) {
                            throw new Error('ValueSet must be provided to InValueSet function');
                        }
                        return [4 /*yield*/, this.codes.exec(ctx)];
                    case 2:
                        codes = _a.sent();
                        return [2 /*return*/, codes != null && codes.some(function (code) { return valueset.hasMatch(code); })];
                }
            });
        });
    };
    return AnyInValueSet;
}(expression_1.Expression));
exports.AnyInValueSet = AnyInValueSet;
var InValueSet = /** @class */ (function (_super) {
    __extends(InValueSet, _super);
    function InValueSet(json) {
        var _this = _super.call(this, json) || this;
        _this.code = (0, builder_1.build)(json.code);
        _this.valueset = new ValueSetRef(json.valueset);
        return _this;
    }
    InValueSet.prototype.exec = function (ctx) {
        return __awaiter(this, void 0, void 0, function () {
            var code, valueset;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        // If the code argument is null, the result is false
                        if (this.code == null) {
                            return [2 /*return*/, false];
                        }
                        if (this.valueset == null) {
                            throw new Error('ValueSet must be provided to InValueSet function');
                        }
                        return [4 /*yield*/, this.code.execute(ctx)];
                    case 1:
                        code = _a.sent();
                        // spec indicates to return false if code is null, throw error if value set cannot be resolved
                        if (code == null) {
                            return [2 /*return*/, false];
                        }
                        return [4 /*yield*/, this.valueset.execute(ctx)];
                    case 2:
                        valueset = _a.sent();
                        if (valueset == null || !valueset.isValueSet) {
                            throw new Error('ValueSet must be provided to InValueSet function');
                        }
                        // If there is a code and valueset return whether or not the valueset has the code
                        return [2 /*return*/, valueset.hasMatch(code)];
                }
            });
        });
    };
    return InValueSet;
}(expression_1.Expression));
exports.InValueSet = InValueSet;
var CodeSystemDef = /** @class */ (function (_super) {
    __extends(CodeSystemDef, _super);
    function CodeSystemDef(json) {
        var _this = _super.call(this, json) || this;
        _this.name = json.name;
        _this.id = json.id;
        _this.version = json.version;
        return _this;
    }
    CodeSystemDef.prototype.exec = function (_ctx) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, new dt.CodeSystem(this.id, this.version)];
            });
        });
    };
    return CodeSystemDef;
}(expression_1.Expression));
exports.CodeSystemDef = CodeSystemDef;
var CodeDef = /** @class */ (function (_super) {
    __extends(CodeDef, _super);
    function CodeDef(json) {
        var _this = _super.call(this, json) || this;
        _this.name = json.name;
        _this.id = json.id;
        _this.systemName = json.codeSystem.name;
        _this.display = json.display;
        return _this;
    }
    CodeDef.prototype.exec = function (ctx) {
        return __awaiter(this, void 0, void 0, function () {
            var system;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, ctx.getCodeSystem(this.systemName).execute(ctx)];
                    case 1:
                        system = _a.sent();
                        return [2 /*return*/, new dt.Code(this.id, system.id, system.version, this.display)];
                }
            });
        });
    };
    return CodeDef;
}(expression_1.Expression));
exports.CodeDef = CodeDef;
var CodeRef = /** @class */ (function (_super) {
    __extends(CodeRef, _super);
    function CodeRef(json) {
        var _this = _super.call(this, json) || this;
        _this.name = json.name;
        _this.library = json.libraryName;
        return _this;
    }
    CodeRef.prototype.exec = function (ctx) {
        return __awaiter(this, void 0, void 0, function () {
            var codeDef;
            return __generator(this, function (_a) {
                ctx = this.library ? ctx.getLibraryContext(this.library) : ctx;
                codeDef = ctx.getCode(this.name);
                return [2 /*return*/, codeDef ? codeDef.execute(ctx) : undefined];
            });
        });
    };
    return CodeRef;
}(expression_1.Expression));
exports.CodeRef = CodeRef;
var Code = /** @class */ (function (_super) {
    __extends(Code, _super);
    function Code(json) {
        var _this = _super.call(this, json) || this;
        _this.code = json.code;
        _this.systemName = json.system.name;
        _this.version = json.version;
        _this.display = json.display;
        return _this;
    }
    Object.defineProperty(Code.prototype, "isCode", {
        // Define a simple getter to allow type-checking of this class without instanceof
        // and in a way that survives minification (as opposed to checking constructor.name)
        get: function () {
            return true;
        },
        enumerable: false,
        configurable: true
    });
    Code.prototype.exec = function (ctx) {
        return __awaiter(this, void 0, void 0, function () {
            var system;
            return __generator(this, function (_a) {
                system = ctx.getCodeSystem(this.systemName) || {};
                return [2 /*return*/, new dt.Code(this.code, system.id, this.version, this.display)];
            });
        });
    };
    return Code;
}(expression_1.Expression));
exports.Code = Code;
var ConceptDef = /** @class */ (function (_super) {
    __extends(ConceptDef, _super);
    function ConceptDef(json) {
        var _this = _super.call(this, json) || this;
        _this.name = json.name;
        _this.display = json.display;
        _this.codes = json.code;
        return _this;
    }
    ConceptDef.prototype.exec = function (ctx) {
        return __awaiter(this, void 0, void 0, function () {
            var codes;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Promise.all(this.codes.map(function (code) { return __awaiter(_this, void 0, void 0, function () {
                            var codeDef;
                            return __generator(this, function (_a) {
                                codeDef = ctx.getCode(code.name);
                                return [2 /*return*/, codeDef ? codeDef.execute(ctx) : undefined];
                            });
                        }); }))];
                    case 1:
                        codes = _a.sent();
                        return [2 /*return*/, new dt.Concept(codes, this.display)];
                }
            });
        });
    };
    return ConceptDef;
}(expression_1.Expression));
exports.ConceptDef = ConceptDef;
var ConceptRef = /** @class */ (function (_super) {
    __extends(ConceptRef, _super);
    function ConceptRef(json) {
        var _this = _super.call(this, json) || this;
        _this.name = json.name;
        return _this;
    }
    ConceptRef.prototype.exec = function (ctx) {
        return __awaiter(this, void 0, void 0, function () {
            var conceptDef;
            return __generator(this, function (_a) {
                conceptDef = ctx.getConcept(this.name);
                return [2 /*return*/, conceptDef ? conceptDef.execute(ctx) : undefined];
            });
        });
    };
    return ConceptRef;
}(expression_1.Expression));
exports.ConceptRef = ConceptRef;
var Concept = /** @class */ (function (_super) {
    __extends(Concept, _super);
    function Concept(json) {
        var _this = _super.call(this, json) || this;
        _this.codes = json.code;
        _this.display = json.display;
        return _this;
    }
    Object.defineProperty(Concept.prototype, "isConcept", {
        // Define a simple getter to allow type-checking of this class without instanceof
        // and in a way that survives minification (as opposed to checking constructor.name)
        get: function () {
            return true;
        },
        enumerable: false,
        configurable: true
    });
    Concept.prototype.toCode = function (ctx, code) {
        var system = ctx.getCodeSystem(code.system.name) || {};
        return new dt.Code(code.code, system.id, code.version, code.display);
    };
    Concept.prototype.exec = function (ctx) {
        return __awaiter(this, void 0, void 0, function () {
            var codes;
            var _this = this;
            return __generator(this, function (_a) {
                codes = this.codes.map(function (code) { return _this.toCode(ctx, code); });
                return [2 /*return*/, new dt.Concept(codes, this.display)];
            });
        });
    };
    return Concept;
}(expression_1.Expression));
exports.Concept = Concept;
var CalculateAge = /** @class */ (function (_super) {
    __extends(CalculateAge, _super);
    function CalculateAge(json) {
        var _this = _super.call(this, json) || this;
        _this.precision = json.precision;
        return _this;
    }
    CalculateAge.prototype.exec = function (ctx) {
        return __awaiter(this, void 0, void 0, function () {
            var date1, date2, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.execArgs(ctx)];
                    case 1:
                        date1 = _a.sent();
                        date2 = dt.DateTime.fromJSDate(ctx.getExecutionDateTime());
                        result = date1 != null ? date1.durationBetween(date2, this.precision.toLowerCase()) : undefined;
                        if (result != null && result.isPoint()) {
                            return [2 /*return*/, result.low];
                        }
                        else {
                            return [2 /*return*/, result];
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    return CalculateAge;
}(expression_1.Expression));
exports.CalculateAge = CalculateAge;
var CalculateAgeAt = /** @class */ (function (_super) {
    __extends(CalculateAgeAt, _super);
    function CalculateAgeAt(json) {
        var _this = _super.call(this, json) || this;
        _this.precision = json.precision;
        return _this;
    }
    CalculateAgeAt.prototype.exec = function (ctx) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, date1, date2, result;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.execArgs(ctx)];
                    case 1:
                        _a = _b.sent(), date1 = _a[0], date2 = _a[1];
                        if (date1 != null && date2 != null) {
                            // date1 is the birthdate, convert it to date if date2 is a date (to support ignoring time)
                            if (date2.isDate && date1.isDateTime) {
                                date1 = date1.getDate();
                            }
                            result = date1.durationBetween(date2, this.precision.toLowerCase());
                            if (result != null && result.isPoint()) {
                                return [2 /*return*/, result.low];
                            }
                            else {
                                return [2 /*return*/, result];
                            }
                        }
                        return [2 /*return*/, null];
                }
            });
        });
    };
    return CalculateAgeAt;
}(expression_1.Expression));
exports.CalculateAgeAt = CalculateAgeAt;
//# sourceMappingURL=clinical.js.map